export default "__VITE_PUBLIC_ASSET__59761c62__"